module.exports = __webpack_public_path__ + "static/img/logo.37af3ed5.png";